import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

/** 레거시 appr_edit_forms_open_construction_cost 스타일 1:1 — 루트가 레거시 .open-construction-cost */
export const OpenConstructionCostRoot = styled(Box)`
  /* 레거시 부트스트랩 유틸 — 이 양식 안에서만 */
  font-size: 16px;
  color: var(--dk-text-primary, #333);
  & .d-block {
    display: block;
  }
  & .mb-0 {
    margin-bottom: 0;
  }
  & .mb-5 {
    margin-bottom: 5px;
  }
  & .mb-10 {
    margin-bottom: 10px;
  }
  & .mb-40 {
    margin-bottom: 40px;
  }
  & .mt-5 {
    margin-top: 5px;
  }
  & .mt-10 {
    margin-top: 10px;
  }
  & .mt-40 {
    margin-top: 40px;
  }
  & .pb-20 {
    padding-bottom: 20px;
  }
  & .text-right {
    text-align: right;
  }
  & .text-center {
    text-align: center;
  }
  & .text-muted {
    color: var(--dk-text-secondary, #777);
  }
  & p {
    margin: 0 0 10px;
  }
  & .table {
    width: 100%;
    max-width: 100%;
    margin-bottom: 20px;
    border-collapse: collapse;
    border-spacing: 0;
  }
  & .table th,
  & .table td {
    padding: 8px;
    line-height: 1.42857143;
    vertical-align: top;
  }
  & .table th {
    text-align: left;
  }
  & .table th.text-right,
  & .table td.text-right {
    text-align: right;
  }
  & .table th.text-center,
  & .table td.text-center {
    text-align: center;
  }

  & .scroll-x {
    max-width: 100%;
    overflow-x: auto;
  }
  & {
    font-size: 16px;
  }
  & .section-title {
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    margin-bottom: 16px;
  }

  & .info-grid {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    gap: 16px;
    margin: 16px 0;
  }
  & .info-item {
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid var(--dk-line, rgb(231, 233, 236));
    padding: 8px 0;
  }
  & .info-label {
    min-width: 136px;
    font-size: 14px;
    color: var(--dk-text-strong, #5f636b);
  }
  & .info-value {
    font-size: 16px;
    color: var(--dk-text-primary, #333);
  }
  & .info-value.content {
    white-space: pre-line;
    line-height: 1.5;
  }
  & .brand-info {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  & .brand-logo {
    width: 24px;
    height: 24px;
    background: black;
    border-radius: 4px;
  }
  & .budget-summary {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
  }
  & .section-title {
    margin-bottom: 0;
  }

  @media screen and (max-width: 990px) {
    & .info-item {
      display: flex;
      flex-direction: column;
      gap: 16px;
    }

    & .budget-summary {
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
    }
  }

  & .table-container {
    position: relative;
    overflow-x: auto;
  }

  & .table,
  & .table th,
  & .table td {
    border: 1px solid var(--dk-line, #e0e2e5);
  }
  & .table .col-flex {
    min-width: 110px;
  }
  & .table thead th {
    padding: 8px 4px;
    min-height: 14px;
    line-height: 1.4;
    font-weight: 500;
    vertical-align: middle;
    background-color: var(--dk-bg-subtle, #f9fafb);
  }
  & .table tbody td {
    background-color: var(--dk-bg, #fff);
  }
  & .table td {
    min-height: 40px;
  }
  & .table tfoot tr:first-child {
    border-top: 3px solid var(--dk-line, #e0e2e5);
  }
  & .table tfoot td {
    background-color: var(--dk-bg-subtle, #f9fafb);
  }

  /* 공사비 요약 표 — Card-Status 기준 컬럼 너비(colgroup) 유지, 좁으면 가로 스크롤 */
  & .budget-table {
    table-layout: fixed;
    min-width: 1192px;
  }
  & .budget-table th,
  & .budget-table td {
    font-size: 18px;
  }
  /* 비교군 대비 · 판정 — 줄바꿈 방지 */
  & .budget-table th:nth-child(5),
  & .budget-table td:nth-child(5),
  & .budget-table th:nth-child(6),
  & .budget-table td:nth-child(6) {
    white-space: nowrap;
  }

  /* ===================== 공사비 적정성 — 신규 UI ===================== */
  /* 섹션 공통 */
  & .cc-section {
    margin: 24px 0;
  }
  & .section-divider {
    border: 0;
    border-top: 1px solid var(--dk-line, #e7e9ec);
    margin: 24px 0;
  }

  /* AI 라벨 pill */
  & .ai-pill {
    display: inline-flex;
    align-items: center;
    padding: 4px 12px;
    border-radius: 999px;
    background: #0066cc;
    color: #fff;
    font-size: 14px;
    line-height: 20px;
  }

  /*
        * 재사용 컬러 유틸 — 넘어오는 값/상태에 따라 modifier 클래스만 교체해서 사용.
        * 상태 뱃지: .status-tag + (.is-success 적정·우수 | .is-caution 재검토·주의(비교군) | .is-warning 주의(투자회수) | .is-blue 매우우수 | .is-default 보통 | .is-violet)
        * 값 색상  : .val-success(초록) | .val-caution(빨강) | .val-blue | .val-violet
        */
  & .status-tag {
    display: inline-flex;
    align-items: center;
    padding: 4px 8px;
    border: 1px solid var(--dk-line, #e7e9ec);
    border-radius: 4px;
    background: var(--dk-bg, #fff);
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    white-space: nowrap;
  }
  & .status-tag.is-success {
    color: #43b16f;
  } /* 적정·우수 */
  & .status-tag.is-caution {
    color: var(--dk-danger, #f55060);
  } /* 재검토·비교군 주의 */
  & .status-tag.is-warning {
    color: #ff9a15;
  } /* 투자회수 주의 */
  & .status-tag.is-blue {
    color: var(--dk-accent, #0066cc);
  } /* 매우우수 */
  & .status-tag.is-default {
    color: var(--dk-text, #000000);
  } /* 보통 */
  & .status-tag.is-violet {
    color: #694ba8;
  }
  /* 값 옆 상태 라벨 (회수 속도 / 이익률) */
  & .metric-row {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  & .mini-table td .status-tag {
    margin-left: 6px;
    vertical-align: middle;
  }

  & .val-success {
    color: #43b16f;
  }
  & .val-caution {
    color: var(--dk-danger, #f55060);
  }
  & .val-blue {
    color: var(--dk-accent, #0066cc);
  }
  & .val-violet {
    color: #694ba8;
  }

  /* AI 텍스트(종합의견/특이사항)에 들어오는 인라인 강조 (서버 HTML이 .highlight / .badge-status 사용) */
  & .highlight {
    font-weight: 700;
  }
  & .badge-status {
    display: inline-block;
    padding: 0 6px;
    border-radius: 4px;
    font-size: 0.875em;
    font-weight: 700;
  }
  & .badge-status.warn {
    color: #ff9a15;
    background: var(--dk-warning-soft, #fff4e5);
  }

  /* 매출·손익 요약 표 — 공사비 요약 표와 동일 크기 */
  & .sales-table th,
  & .sales-table td {
    font-size: 18px;
  }
  & .sales-table .th-note {
    font-weight: 400;
    color: var(--dk-text-secondary, #888d96);
  }
  & .sales-table .cell-sub {
    display: block;
    font-size: 16px;
    line-height: 24px;
    color: var(--dk-text-secondary, #888d96);
  }

  /* AI 공사비 적정성 종합의견 */
  & .overall-opinion {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 16px;
    border: 1px solid var(--dk-accent-line, #c2daf3);
    border-radius: 8px;
    background: var(--dk-bg-subtle, #f9fafb);
  }
  /* 종합의견 머리줄 — 좌측 AI 라벨 / 우측 판정기준 토글 */
  & .overall-opinion .opinion-head {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  & .basis-toggle {
    margin-left: auto;
    white-space: nowrap;
  }
  & .overall-opinion .opinion-text {
    font-size: 18px;
    line-height: 26px;
    color: var(--dk-text, #000);
  }

  /* 적정성 카드 (비교군 대비 / 투자회수) */
  & .feasibility-cards {
    display: flex;
    gap: 24px;
    align-items: stretch;
  }
  & .feasibility-card {
    flex: 1 1 0;
    min-width: 306px;
    display: flex;
    flex-direction: column;
    border: 1px solid var(--dk-line, #e7e9ec);
    border-radius: 8px;
    overflow: hidden;
    box-shadow: inset 0 0 4px 0 rgba(0, 0, 0, 0.08),
      0 0 8px 0 rgba(0, 0, 0, 0.08);
  }
  & .feasibility-card .card-head {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px;
  }
  & .feasibility-card .card-title {
    flex: 1 1 0;
    min-width: 0;
    font-size: 18px;
    font-weight: 500;
    line-height: 26px;
  }
  & .feasibility-card .card-divider {
    width: 100%;
    height: 1px;
  }
  & .feasibility-card .card-body {
    flex: 1 1 auto;
    display: flex;
    flex-direction: column;
    gap: 16px;
    padding: 12px;
    background: var(--dk-bg, #fff);
  }
  & .feasibility-card .card-caption {
    font-size: 14px;
    line-height: 20px;
    color: var(--dk-text-secondary, #888d96);
  }
  & .feasibility-card .card-metric {
    font-size: 40px;
    font-weight: 500;
    line-height: 1.2;
  }
  & .feasibility-card .card-subcaption {
    font-size: 16px;
    line-height: 24px;
    color: var(--dk-text, #000);
  }
  & .feasibility-card .card-reason {
    font-size: 18px;
    line-height: 26px;
    color: var(--dk-text, #000);
  }
  /* blue 테마 */
  & .feasibility-card.is-blue {
    border-color: var(--dk-accent-line, #c2daf3);
  }
  & .feasibility-card.is-blue .card-head {
    background: var(--dk-accent-soft, #ebf3fb);
  }
  & .feasibility-card.is-blue .card-divider {
    background: var(--dk-accent-tint, #c2daf3);
  }
  /* violet 테마 */
  & .feasibility-card.is-violet {
    border-color: #cecddf;
  }
  & .feasibility-card.is-violet .card-head {
    background: #f0eef7;
  }
  & .feasibility-card.is-violet .card-title {
    color: #694ba8;
  }
  & .feasibility-card.is-violet .card-divider {
    background: #cecddf;
  }

  /* 카드 내부 미니 테이블 */
  & .mini-table {
    width: 100%;
    border: 1px solid var(--dk-line, #e7e9ec);
    border-radius: 2px;
    border-collapse: separate;
    border-spacing: 0;
    overflow: hidden;
  }
  & .mini-table th,
  & .mini-table td {
    padding: 8px;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    border-bottom: 1px solid var(--dk-line, #e7e9ec);
  }
  & .mini-table tr:last-child th,
  & .mini-table tr:last-child td {
    border-bottom: 0;
  }
  & .mini-table th {
    width: 144px;
    text-align: left;
    background: var(--dk-bg-subtle, #f9fafb);
    border-right: 1px solid var(--dk-line, #e7e9ec);
    color: var(--dk-text, #000);
  }
  & .mini-table td {
    text-align: right;
    background: var(--dk-bg, #fff);
    color: var(--dk-text, #000);
  }

  /* 카드 노트(설계등급) 박스 */
  & .card-note {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 8px;
    border: 1px solid var(--dk-line, #e7e9ec);
    border-radius: 2px;
    background: var(--dk-bg-subtle, #f9fafb);
  }
  & .card-note .note-chip {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    align-self: flex-start;
    padding: 4px 8px;
    border: 1px solid var(--dk-line, #e7e9ec);
    border-radius: 4px;
    background: var(--dk-bg, #fff);
    font-size: 14px;
    line-height: 20px;
  }
  & .card-note .note-chip .chip-divider {
    width: 1px;
    height: 12px;
    background: var(--dk-bg-strong, #e7e9ec);
  }
  & .card-note .note-desc {
    font-size: 16px;
    line-height: 24px;
    color: var(--dk-text-secondary, #888d96);
  }

  /* 투자회수 시나리오 */
  & .scenario {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  & .scenario .scenario-item {
    flex: 1 1 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    padding: 12px 0;
    text-align: center;
  }
  & .scenario .scenario-label {
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    color: var(--dk-text-secondary, #888d96);
  }
  & .scenario .scenario-val {
    font-size: 20px;
    line-height: 28px;
    color: var(--dk-text, #000);
  }
  & .scenario .scenario-divider {
    width: 1px;
    height: 32px;
    background: var(--dk-bg-strong, #e7e9ec);
  }

  /* AI 공사내용 특이사항 분석 (종합의견과 동일한 박스) */
  & .special-notes {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 16px;
    border: 1px solid var(--dk-accent-line, #c2daf3);
    border-radius: 8px;
    background: var(--dk-bg-subtle, #f9fafb);
  }
  & .special-notes .notes-body {
    font-size: 18px;
    line-height: 36px;
    color: var(--dk-text, #000);
  }
  & .special-notes .notes-body h4 {
    font-size: 18px;
    font-weight: 700;
    line-height: 36px;
    margin: 16px 0 0;
  }
  & .special-notes .notes-body h4:first-child {
    margin-top: 0;
  }
  & .special-notes .notes-body p {
    margin: 0;
  }

  /* 공사비 요약 — 판정 딱지 (재사용: is-caution=높음, is-success=적정) */
  & .judge-tag {
    display: inline-flex;
    align-items: center;
    gap: 2px;
    padding: 4px 8px 4px 4px;
    border-radius: 4px;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    white-space: nowrap;
  }
  & .judge-tag .arrow {
    flex-shrink: 0;
  }
  & .judge-tag.is-caution {
    background: var(--dk-danger-soft, #fef1f2);
    color: var(--dk-danger, #f55060);
  }
  & .judge-tag.is-success {
    background: #f0f9f3;
    color: #43b16f;
  }

  @media screen and (max-width: 990px) {
    & .feasibility-cards {
      flex-direction: column;
    }
    & .feasibility-card {
      flex: 0 0 auto;
    }
    /* 좁은 화면: 버튼 → AI 라벨 → 본문 순으로 쌓아 겹침 방지 */
    & .overall-opinion .opinion-head {
      flex-direction: column-reverse;
      align-items: flex-start;
    }
    & .basis-toggle {
      margin-left: 0;
    }
  }
`;
